export const config = {
  apiUrl: window.location.origin,
  reCAPTCHASiteKey: "6LezCHApAAAAABSego_H-WkK1VNXTRkYw94P4Elz",
  // DEV & Local: "6LcWBHApAAAAAGFTAirj2XYvZ4hO9SG_6r6OOcqY"
  gaTrackingId: "G-1CKRRDMZ9B",
};
